import { HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

const HEADER_CONFIG = {
//   'Content-Type': 'application/json',
//   'Accept': 'application/json',
  'Authorization': ''
};

@Injectable()
export class JwtService {
    private readonly JWT_KEY = 'jwt';
    token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiM2FlNzczYzQwMGUyMzVhYTgxY2E1MjVhNDZhYzVkMjRlZDQ3OGQ4MzMyNDQ2MmRjYTc1NzcwMzAwYWI3OTBiMDE1MGIwMTYxZjI2MmYzZjQiLCJpYXQiOjE2NDczNTQ2MTYuNjkzNjY3LCJuYmYiOjE2NDczNTQ2MTYuNjkzNjcsImV4cCI6MTY3ODg5MDYxNi42OTAwMjksInN1YiI6IjIiLCJzY29wZXMiOltdfQ.5FpHH-dZ7fWv8veEUTm0wDdCalEAfj9xF0bmXN3tZtsHwOEEHoVjikXEw-w03otB0W4kDkFuiren5gdF_K2oCFR5xc8dXVglr3qRDCW_QWyQzkFZ-Rm3QFH4Ugp9O6N-55jIVIO2BeiijZE8AwOPuMo1UeJY1qWjMWxskMAN4gGDWKdu7HsuNKI2GQwVIz2wnM2KWRbSn0-ZWlhWqqNoVfkr1zIyVJem98Q-icE1jfsMSeRDdCk-xjX-fx8zRzGwwQxO6cJaoSeN3P7CIlhbqsgGLKQSP8EV7kPkHRUh6pRJyrGNIQJXFzxDcits3CeF7-cnq7HR-XNxFMug2ylVXqvN-DgvqC5CZW8ksV2aFLh_Bco9jAImWPScGlJ_Lsvf-T8zXJG1zFYFi0pHeIJvJJawRQ9S1A2BpuAt-Z3T_6kLBsU87NfE8Plr-VnFsuFcmyOQQXwvGkvLRcI_REXfZBn0aN2DHfN1Ubz3bONIrxInAWL3jdmVF8g5OUBeN3ez896U71R-5PBZgMSicmkSDpdg5mr9Gnpe-AX2ZZN4VpyJLzBnftmkFMjXD5DiOZX1aTvmraM_tS-Rou3K6yvsvqs2VPUrhhTN85dU8oOTdpXk_vO7iNobSPf7aaJvsPeQrXniGNldpnMEKzK4PpVg2yF9DNcOHo_7rdJOBSOWk94';

    getTocken() {
        return localStorage.getItem(this.JWT_KEY);
    }
    
    removeTocken() {
        localStorage.removeItem(this.JWT_KEY);
    }

    setTocken(token: string) {
        localStorage.setItem(this.JWT_KEY, token);
    }

    addTokenToReq(req: HttpRequest<any>, token: string) {
        if(token) HEADER_CONFIG['Authorization'] = `Bearer ${token}`;
        return req.clone({
            setHeaders: HEADER_CONFIG
        });
    }

}